import client from './client';
import './theme/index.scss';

if (process.env.REACT_APP_MOCK) {
  const { worker } = require('./mocks/browser');
  worker.start();
}

client();
